// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-tips[data-v-110ee2aa] {\n  padding-bottom: 10px;\n  color: #333;\n}\n.title-tips span[data-v-110ee2aa] {\n  margin-right: 14px;\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
